export class MediaGalleryItem {

    private content: string;
    private contentThumbnail: string;
    private cycles: number;
    private duration: number;
    private height: number;
    private id: string;
    private selected: boolean;
    private title: string;
    private type: 'IMAGE_FILE' | 'IMAGE_URL' | 'VIDEO_FILE' | 'VIDEO_URL' | 'VIDEO_YOUTUBE' | 'WEB' | 'WEB_SCRIPT' | 'WEB_URL';
    private width: number;
    private zoomLevel: number;

    constructor(id?: string, title?: string, type?: 'IMAGE_FILE' | 'IMAGE_URL' | 'VIDEO_FILE' | 'VIDEO_URL' | 'VIDEO_YOUTUBE' | 'WEB_SCRIPT' | 'WEB_URL', content?: string, contentThumbnail?: string, selected?: boolean, cycles?: number, duration?: number, width?: number, height?: number, zoomLevel?: number) {
        this.content = content;
        this.contentThumbnail = contentThumbnail;
        this.cycles = cycles;
        this.duration = duration;
        this.height = height;
        this.id = id;
        this.selected = selected;
        this.title = title;
        this.type = type;
        this.width = width;
        this.zoomLevel = zoomLevel;
    }

    public get Content() {
        return this.content;
    }
    public get ContentThumbnail() {
        return this.contentThumbnail;
    }
    public get Cycles() {
        return this.cycles;
    }
    public get Duration() {
        return this.duration;
    }
    public get Height() {
        return this.height;
    }
    public get Id() {
        return this.id;
    }
    public get Selected() {
        return this.selected;
    }
    public get Title() {
        return this.title;
    }
    public get Type() {
        return this.type;
    }
    public get Width() {
        return this.width;
    }
    public get ZoomLevel() {
        return this.zoomLevel;
    }
    public set Content(content) {
        this.content = content;
    }
    public set ContentThumbnail(contentThumbnail) {
        this.contentThumbnail = contentThumbnail;
    }
    public set Cycles(cycles) {
        this.cycles = cycles;
    }
    public set Duration(duration) {
        this.duration = duration;
    }
    public set Height(height) {
        this.height = height;
    }
    public set Id(id) {
        this.id = id;
    }
    public set Selected(selected) {
        this.selected = selected;
    }
    public set Title(title) {
        this.title = title;
    }
    public set Type(type) {
        this.type = type;
    }
    public set Width(width) {
        this.width = width;
    }
    public set ZoomLevel(zoomLevel) {
        this.zoomLevel = zoomLevel;
    }
}
